// 環境スナップショット（v0.6.0）。現在の時間帯・季節をまとめて算出する純関数。
//
// main / ステータス画面 / 描画は「今この瞬間の環境」を 1 か所から得たい。simulate は
// 来店刻みごとに atMs から内部評価するが、UI/描画は表示用に現在時刻の環境を必要とする。
// ここはその橋渡し（時刻 + 庭デコ集合 → TimeOfDay/Season）。
//
// ?demo の帯固定（tod=night 等）にも使えるよう override を受け付ける。

import type { GameState } from './state';
import type { TimeOfDay } from './daynight';
import { timeOfDayForMs } from './daynight';
import type { Season } from './season';
import { effectiveSeason } from './season';

/** 現在の環境スナップショット。 */
export interface EnvSnapshot {
  tod: TimeOfDay;
  season: Season;
}

/** override（?demo 用に帯/季節を固定する）。 */
export interface EnvOverride {
  tod?: TimeOfDay;
  season?: Season;
}

/** 全アンロック島に置かれているデコ ID を集める（季節固定の判定に使う、v0.7.1）。 */
function decoIdsOf(state: GameState): string[] {
  const out: string[] = [];
  const n = Math.min(state.unlockedIslands, state.islands.length);
  for (let i = 0; i < n; i++) {
    for (const cell of state.islands[i].garden) if (cell) out.push(cell.decoId);
  }
  return out;
}

/**
 * 状態と現在時刻から環境を算出する。override があればそれを優先（?demo 固定用）。
 *
 * @param state    ゲーム状態（季節固定の判定に庭デコを見る）。
 * @param nowMs    現在時刻（エポックミリ秒）。
 * @param override 表示・スクショ用の固定値（任意）。
 */
export function currentEnv(state: GameState, nowMs: number, override?: EnvOverride): EnvSnapshot {
  const tod = override?.tod ?? timeOfDayForMs(nowMs);
  const season = override?.season ?? effectiveSeason(nowMs, decoIdsOf(state));
  return { tod, season };
}
